exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application a,.v-application a:visited{text-decoration:none;-webkit-transition:color .15s ease;transition:color .15s ease}.v-application a:hover{color:var(--v-primary-darken1)}.v-application *>p:last-of-type{margin-bottom:0}.contact-card,.contact-card__wrap{position:relative;overflow:hidden}.contact-card__wrap{padding:2px}.contact-card__lines{left:0}.contact-card__emblem,.contact-card__lines{position:absolute;top:0;width:100%;height:100%}.contact-card__emblem{right:0;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
